<script lang="ts">
	import type { IconName } from '$lib/components/icons/types';
	import type { PoiSummaryScheme } from '$lib/components/pois/types';
	import type { Snippet } from 'svelte';
	import PoiSummaryImage from './PoiSummaryImage.svelte';

	interface Props {
		name: string;
		color: PoiSummaryScheme;
		icon?: IconName;
		imageUrl?: string | null;
		infos?: Snippet;
		buttons?: Snippet;
		note?: Snippet;
	}

	const {
		name,
		color,
		icon = undefined,
		imageUrl = null,
		infos,
		buttons,
		note,
	}: Props = $props();

	const infosClasses: Record<PoiSummaryScheme, string> = {
		hotel: 'text-hotel rowformattedinfos',
		hotelMichelin: 'text-hotel-michelin rowformattedinfos',
		restaurant: 'text-restaurant rowformattedinfos',
		restaurantMichelin: 'text-restaurant-michelin rowformattedinfos',
		tourism: 'text-tourism rowformattedinfos',
		parking: 'text-coloredneutral rowformattedinfos compactrows',
		rest: 'text-coloredneutral rowformattedinfos compactrows',
		energy: 'text-coloredneutral',
	};
</script>

<div
	class="poi-summary flex flex-row gap-1 relative rd-2 shadow-subtle p-1 bg-neutral-weakest w-full"
>
	{#if imageUrl}
		<PoiSummaryImage src={imageUrl} {icon} {color} />
	{/if}

	<div class={['flex flex-col pt-1 px-1 min-w-0 flex-grow', imageUrl === null && 'pb-1']}>
		<div class="truncate text-md text-bold text-coloredneutral">
			{name}
		</div>
		{#if infos}
			<div class={['flex flex-col text-sm flex-grow', infosClasses[color]]}>
				{@render infos?.()}
			</div>
		{/if}
		<div class="flex flex-row justify-between w-full">
			{#if buttons}
				<div class="flex flex-row gap-2 mt-2">
					{@render buttons?.()}
				</div>
			{/if}
			{#if note}
				<div class="flex flex-row gap-2 mt-2">
					{@render note?.()}
				</div>
			{/if}
		</div>
	</div>
</div>

<style>
	.rowformattedinfos > :global(div) {
		height: 24px;
		display: flex;
		flex-direction: row;
		align-items: center;
	}

	.compactrows > :global(div) {
		height: 20px;
	}
</style>
